import FileApi from './rest/FileApi';

export default new FileApi();
